import React from 'react'
import AnnualdayGallery from '../components/Annualday'
import Footer from '../components/footer'
export default function Annualday() {
  return (
    <div>
      <AnnualdayGallery />
      <Footer />
    </div>
  )
}
